import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { selectSession, selectClinic, clearSession } from "../../store";
import { SESSION_EXPIRED_EVENT } from "../../domain/datasources/http";

const SESSION_EXPIRED_MESSAGE = "Sua sessão expirou. Faça login novamente.";

export const SessionExpiredHandler = () => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const session = useSelector(selectSession);
  const clinic = useSelector(selectClinic);

  const handleSessionExpired = useCallback(() => {
    const isPatient = !!session.patient && !session.role;
    const clinicId = clinic.id;

    dispatch(clearSession());
    window.sessionStorage.clear();

    setOpen(true);

    if (!clinicId) {
      return navigate("/", { replace: true });
    }

    const loginPath = isPatient
      ? `/${clinicId}/agendar`
      : `/${clinicId}/entrar`;

    navigate(loginPath, {
      state: { from: location },
      replace: true,
    });
  }, [dispatch, navigate, location, session, clinic]);

  useEffect(() => {
    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);

    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    };
  }, [handleSessionExpired]);

  const handleClose = () => setOpen(false);

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="warning" sx={{ width: "100%" }}>
        {SESSION_EXPIRED_MESSAGE}
      </Alert>
    </Snackbar>
  );
};
